/* tslint:disable:no-console */

import { register } from "register-service-worker";
import ErrorHandler from "@/support/ErrorHandler";
import { Config } from "@/core";

if (Config.get('NODE_ENV') === "production") {
  register(`/service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updated() {
      location.reload();
    },
    offline() {
      ErrorHandler.updated(
        "No internet connection found. App is running in offline mode and may be unresponsive."
      );
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
